import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { useIsMobile } from '../../hooks/useIsMobile';
import Details from './Details';
import Image from './Image';
import ContactActions from './ContactActions';
import ModalCard from './ModalCard';
import { StaffMemberShape } from '../../global-constants';

const VCard = ({ staffMember, delayLoadImage }) => {
	const {
		imageShape,
		squareImagePadding,
		verticalImageBackgroundColor,
		disableVCardSpacing
	} = usePrefs();
	const { name, photo, department } = staffMember;
	const isCircleImg = imageShape === 'circle';

	const { isMobile } = useIsMobile();

	const getDetailsContainerClasses = () => {
		// The details container is both a flex child and a flex container,
		// and we want it to take all available horizontal space
		const containerCls = [
			'flex-grow-1',
			'd-flex',
			'flex-column',
			'px-5',
			'pb-6',
			'text-center'
		];

		// Prevents doubling the amount of empty white space between images and the details container
		// for specific pref combinations
		if (
			(squareImagePadding === 'true' && !isCircleImg) ||
			(isCircleImg && verticalImageBackgroundColor !== 'bg-transparent')
		) {
			containerCls.push('pt-5');
		}

		return containerCls.join(' ');
	};

	return (
		<div
			// We want the vCard to take up all available vertical space while having a specific width
			// This width value comes from the Figma Mockups from the UX Team
			className="d-flex flex-column h-100 box box-border"
			style={{ width: '280px' }}
			data-testid="vCard"
		>
			<div
				className={`img-container ${verticalImageBackgroundColor}`}
				style={{ maxWidth: '280px' }}
				data-testid="vCardImgContainer"
			>
				<Image
					name={name}
					department={department}
					url={photo}
					delayLoadImage={delayLoadImage}
					isWithinModal={false}
				/>
			</div>
			{/*
				These 'minHeight' values were derived by trial and error to align with design mockups from the UX Team,
				and are necessary for the details container to not shrink and take up a specific minimum of vertical space
			*/}

			{(() => {
				let minHeight = '';
				if (disableVCardSpacing !== 'true') {
					minHeight = isMobile ? '20rem' : '14rem';
				}

				return (
					<div
						className={getDetailsContainerClasses()}
						style={{ minHeight }}
					>
						<Details
							isWithinModal={false}
							staffMember={staffMember}
						/>
						<ContactActions
							staffMember={staffMember}
							isWithinModal={false}
						>
							<ModalCard staffMember={staffMember} />
						</ContactActions>
					</div>
				);
			})()}
		</div>
	);
};

VCard.propTypes = {
	staffMember: PropTypes.shape(StaffMemberShape),
	delayLoadImage: PropTypes.bool.isRequired
};

export default VCard;
